import React from "react";
import axios from "axios";
import "./style/solutions.css";
import Slider from "react-slick";
import MapAddresse from "../home/mapAdresse";
import NewsLetter from "../home/newsLetter";
import Footer from "../home/footer";
import ico_client from "../assets/images_page_solutions/Section_pourquoi/ico_client.svg";
import ico_experience from "../assets/images_page_solutions/Section_pourquoi/ico_experience.svg";
import ico_innovation from "../assets/images_page_solutions/Section_pourquoi/ico_innovation.svg";
import ico_souplesse from "../assets/images_page_solutions/Section_pourquoi/ico_souplesse.svg";
import "../home/style/team.css";

import ico_camera from "../assets/images_page_solutions/chifco_iot/smart.svg";
import ico_flotte from "../assets/images_page_solutions/chifco_iot/flotte.svg";
import ico_tracker from "../assets/images_page_solutions/chifco_iot/traqueurs.svg";

import ico_360 from "../assets/images_page_solutions/chifco_vas/360.svg";
import ico_magic from "../assets/images_page_solutions/chifco_vas/magicvoice.svg";
import ico_notif from "../assets/images_page_solutions/chifco_vas/notification.svg";
import ico_vid from "../assets/images_page_solutions/chifco_vas/ad.svg";
import ico_vms from "../assets/images_page_solutions/chifco_vas/bms.svg";

import ico_chat from "../assets/images_page_solutions/chifco_ia/chatbot.svg";
import ico_estimation from "../assets/images_page_solutions/chifco_ia/churn.svg";
import ico_FO from "../assets/images_page_solutions/chifco_ia/forecatsit.svg";
import ico_Machine from "../assets/images_page_solutions/chifco_ia/machine.svg";

import ico_acc from "../assets/images_page_solutions/chifco_consulting/accompagnement.svg";
import ico_expert from "../assets/images_page_solutions/chifco_consulting/expertise.svg";
import ico_integration from "../assets/images_page_solutions/chifco_consulting/integration.svg";

import Object_solutions from "../assets/header_bg/Objet_solutions.png";

import backChifcoIOT from "../assets/images_page_solutions/chifco_iot/background_slide1.png";
import backChifcoVas from "../assets/images_page_solutions//chifco_vas/background_vas.png";
import backChifcoIA from "../assets/images_page_solutions/chifco_ia/background_ia.png";
import backChifcoConsult from "../assets/images_page_solutions/chifco_consulting/background_consult.png";

import ReactSVG from "react-svg";

import Menu from "../home/Menu";
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import { DeviceScreenLockLandscape } from "material-ui/svg-icons";
import Grid from "@material-ui/core/Grid";

import { Helmet } from "react-helmet";

import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   dataLayer: {
//     userProject: "Chifco_website",
//     page: "Solution",
//   },
//   dataLayerName: "PageDataLayer",
// };

const contentStyle = {
  position: "relative",
  background: "linear-gradient(to right, #0c0abe , #07054c)",
  border: "none",
  width: "100%",
  textAlign: "center",
  padding: "0px !important",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "80px",
  paddingBottom: "100%",
};
const TypeSolution = (props) => (
  <div>
    <div style={{ display: "flex" }}>
      <div style={{ padding: "2%" }}>
        <ReactSVG
          style={{ width: "50%" }}
          src={
            `${process.env.REACT_APP_SERVER}` +
            "/images/" +
            props.typesolution.icon
          }
        />
      </div>
      <div>
        <hr style={{ height: "30px" }} />
      </div>
      <div style={{ paddingLeft: "3%" }}>
        <p style={{ color: "#18194b", fontFamily: "Oswald", fontSize: "18px" }}>
          {props.typesolution.title}
        </p>
        <p
          style={{
            color: "#98159b",
            fontFamily: "Open Sans",
            fontWeight: "400",
            fontSize: "15px",
          }}
        >
          {props.typesolution.titleFrench}
        </p>
      </div>
    </div>
    <div>
      <p
        style={{
          fontFamily: "Open Sans",
          color: "#58585b",
          fontWeight: "400",
          lineHeight: "27px",
          fontSize: "15px",
        }}
      >
        {props.typesolution.description}
      </p>
    </div>
  </div>
);
const Solution = (props) => (
  <div>
    <div className="flexSlideSol">
      <div
        style={{
          background: "linear-gradient(to right, #0c0abe , #07054c)",
          padding: "3%",
          display: "flow",
          flexDirection: "column",
        }}
      >
        <div>
          <p className="titleSlide">{props.solution.title}</p>
        </div>
        {/* <div style={{ display:"flex",
           }}> */}
        <div className="topTable">
          <div className="topCell">
            <p className="contenuText">{props.description}</p>
            {props.solution.solutions.map((solution) => {
              return (
                //   <li>

                <div key ={solution._id } style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ paddingTop: "2%", marginRight: "10px" }}>
                    <p className="NomParag">{solution.title}</p>
                    <p className="contenuText">{solution.description}</p>
                  </div>
                  <div className="cercleSmart">
                    <ReactSVG
                      src={
                        `${process.env.REACT_APP_SERVER}` +
                        "/images/" +
                        solution.icon
                      }
                      svgStyle={{
                        width: "50%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block",
                        marginTop: "25%",
                      }}
                    />
                  </div>
                </div>

                //   </li>
              );
            })}
          </div>
        </div>
        {/* </div>  */}
      </div>

      <img alt="" src={backChifcoIOT} className="backChif" />
    </div>
  </div>
);
class Solutions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Solutions: [],
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/solutionT/")
      .then((response) => {
        this.setState({ Solutions: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  TypeSolutionList() {
    return this.state.Solutions.map((currentSolution) => {
      return (
        // <Grid item xs={6} key={currentSolution._id}>

        <TypeSolution key ={ currentSolution._id} typesolution={currentSolution} />
        // </Grid>
      );
    });
  }

  SolutionList() {
    return this.state.Solutions.map((currentSolution) => {
      return (
        <Solution
          description={currentSolution.description2}
          solution={currentSolution}
          key={currentSolution._id}
        />
      );
    });
  }
  render() {
    //TagManager.dataLayer(tagManagerArgs)
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: false,
    };
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Solutions</title>
          <link
            rel="canonical"
            href={
              //"https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT + 
              "/solutions"
            }
          />
        </Helmet>
        <div className="banniereSolution">
          <div className="menu-horizontal">
            <Menu />
          </div>

          <div className="menuMobile">
            <Popup
              modal
              overlayStyle={{
                background: "linear-gradient(to right, #0c0abe , #07054c)",
                width: "100%",
              }}
              contentStyle={contentStyle}
              closeOnDocumentClick={false}
              trigger={(open) => <BurgerIcon open={open} />}
            >
              <SideList />
            </Popup>
          </div>

          <div className="textBanniereSolutions">
            <div className="TitleSlidePagSol">
              <h1 className="sliderTitleSolution">
                Chifco, <br /> votre partenaire
                <br />
                <b style={{ color: "#ffd904" }}>technologique</b>
              </h1>
            </div>
            <div className="divImgObjectSol">
              <img className="imgObjectSol" src={Object_solutions} alt="" />
            </div>
          </div>
        </div>
        <div className="NoSolutionBack">
          <div>
            <h1 className="solutionsTitle">nos Solutions</h1>
          </div>
          <div className="flex-container-Nos-Solution">
            <div style={{  flex: "1" }}>
              <div>
                <p
                  style={{
                    fontFamily: "Oswald",
                    color: "#171850",
                    lineHeight: "25px",
                    fontSize: "27px",
                  }}
                >
                  Des solutions technologiques innovantes et adaptées
                </p>
                <hr
                  style={{ color: "red", width: "20%", marginLeft: "inherit" }}
                />
              </div>
              <div>
                <p
                  style={{
                    fontFamily: "Open Sans",
                    color: "#58585b",
                    fontWeight: "400",
                    lineHeight: "27px",
                    fontSize: "15px",
                  }}
                >
                  Nous proposons des solutions qui créent de la valeur et
                  soutiennent les ambitions de croissance de nos partenaires et
                  clients Business. Notre rôle est de permettre aux entreprises
                  de repenser, ensemble, la meilleure manière d’utiliser leurs
                  données afin de répondre aux problématiques de demain. Nos
                  solutions couvrent essentiellement le domaine de l’Internet
                  des Objets, VAS, l’Intelligence Artificielle et le Consulting.
                </p>
              </div>
            </div>
            {/* <Grid container spacing={2}> */}
            <div className="TypeSolutionListHolder">
              {this.TypeSolutionList()}
            </div>
            {/* </Grid> */}
          </div>
        </div>

        {/* <div className="SolutionsSlides"> */}
        <div>
          {/*Carousellllllllllllll*/}
          <Slider {...settings}>{this.SolutionList()}</Slider>
          <div
            id="dotsdiv"
            style={{
              height: "27px",
              background: "#0c0abe",
              display: "none",
              marginTop: "-1px",
            }}
          >
            {" "}
          </div>
        </div>
        {/* </div> */}
        <div style={{ background: "white", height: "auto" }}>
          <div style={{ padding: "2%" }}>
            <h3 className="solutionsTitle">Pourquoi Chifco ? </h3>
          </div>
          <div className="Solutiontext">
            <div>
              <div style={{ textAlign: "center" }}>
                <ReactSVG className="icon_nos_solution" src={ico_client} />
              </div>
              <div>
                <h2 className="titleSolText">Accompagnement client</h2>
                <p className="paragSolText">
                  Nous vous accompagnons dans toutes les étapes de création de
                  votre solution technologique jusqu'à son implémentation. Notre
                  équipe est à votre écoute et prête à vous assister.
                </p>
              </div>
            </div>
            <div>
              <div style={{ textAlign: "center" }}>
                <ReactSVG className="icon_nos_solution" src={ico_experience} />
              </div>
              <div>
                <h2 className="titleSolText">
                  Expérience et <br />
                  expertise
                </h2>
                <p className="paragSolText">
                  Toute l'équipe de Chifco est triée sur le volet, disposant
                  ainsi d'une solide expérience grâce à des profils qualifiés,
                  complémentaires, et passionnés.
                </p>
              </div>
            </div>
            <div>
              <div style={{ textAlign: "center" }}>
                <ReactSVG className="icon_nos_solution" src={ico_innovation} />
              </div>
              <div>
                <h2 className="titleSolText">
                  Innovation et <br />
                  R&D
                </h2>
                <p className="paragSolText">
                  Chifco place au cœur de son métier la Recherche et
                  l’Innovation afin de vous proposer des solutions toujours plus
                  récentes et optimisées,à la pointe de la technologie pour un
                  meilleur impact sur vos clients cibles.
                </p>
              </div>
            </div>
            <div>
              <div style={{ textAlign: "center" }}>
                <ReactSVG className="icon_nos_solution" src={ico_souplesse} />
              </div>
              <div>
                <h2 className="titleSolText">Souplesse et réactivité </h2>
                <p className="paragSolText">
                  Nous privilégions la relation client pour une parfaite
                  compréhension des attentes et une réponse plus adaptée aux
                  besoins de nos partenaires.
                </p>
              </div>
            </div>
          </div>
        </div>

        <MapAddresse />
        <NewsLetter />
        <Footer />
      </div>
    );
  }
}
export default Solutions;



// WEBPACK FOOTER //
// ./src/pages/solutions.js